import { render, staticRenderFns } from "./RadioRegular.vue?vue&type=template&id=4cc7b4b7&"
import script from "./RadioRegular.vue?vue&type=script&lang=js&"
export * from "./RadioRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports